export default [
    {
        "id": "lookbook",
        "html": require('./lookbook/html').default,
        "js": require('./lookbook/js').default,
        "minJs": require('./lookbook/minJs').default,
        "css": require('./lookbook/css').default,
        "cssTablet": require('./lookbook/cssTablet').default,
        "cssMobile": require('./lookbook/cssMobile').default,
        "scss": require('./lookbook/scss').default,
        "scssTablet": require('./lookbook/scssTablet').default,
        "scssMobile": require('./lookbook/scssMobile').default,
		"relatedBanner": "lookbook"
    }
]